export default "__VITE_ASSET__DGBsZQvg__"